import { useState } from 'react';

const conveniosComTransferenciaRealizada = [
    {
        id: 1,
        convenio: '7º Termo Aditivo ao Convênio 10/2019',
        entidade: 'Instituto Dom Hélder Câmara',
        cnpj: '08.799.272/0001-05',
        data: '01/03/2024',
        valor: 'R$ 144.000,00',
        objeto: 'Assegurar os serviços prestados pelo IDHEC com relação à promoção da capacitação de 90 adolescentes para posterior inserção no mercado de trabalho, fortalecendo as atividades didáticas de educação formal e introduzindo conhecimento para o uso de programas e equipamentos de informática, apoio psicossocial e incentivo à construção da cidadania.',
        documentos: [
            { nome: 'Convênio', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/convenio.pdf' },
            { nome: '1º Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/1-termo-aditivo.pdf' },
            { nome: '2º Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/2-termo-aditivo.pdf' },
            { nome: '3º Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/3-termo-aditivo.pdf' },
            { nome: '4º Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/4-termo-aditivo.pdf' },
            { nome: '5º Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/5-termo-aditivo.pdf' },
            { nome: '6º Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/6-termo-aditivo.pdf' },
            { nome: '7º Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2019/7-termo-aditivo.pdf' }
        ],
        parcelas: [
            { numero: '9ª/12ª', data: '06/02/2025', valor: 'R$ 12.000,00', dataFinal: '08/03/2025', dataPc: '17/02/2025', situacao: 'REGULAR' },
            { numero: '10ª/12ª', data: '13/03/2025', valor: 'R$ 12.000,00', dataFinal: '12/04/2025', dataPc: '25/03/2025', situacao: 'REGULAR' },
            { numero: '11ª/12ª', data: '09/04/2025', valor: 'R$ 12.000,00', dataFinal: '09/05/2025', dataPc: '29/04/2025', situacao: 'REGULAR' },
            { numero: '12ª/12ª', data: '14/05/2025', valor: 'R$ 12.000,00', dataFinal: '13/06/2025', dataPc: '26/05/2025', situacao: 'REGULAR' }
        ]
    },
    {
        id: 2,
        convenio: 'Convênio 002/2025',
        entidade: 'Instituto Dom Hélder Câmara',
        cnpj: '08.799.272/0001-05',
        data: '28/02/2025',
        valor: 'R$ 144.000,00',
        objeto: 'Assegurar os serviços prestados pelo IDHEC com relação à promoção da capacitação de 100 adolescentes para posterior inserção no mercado de trabalho, fortalecendo as atividades didáticas de educação formal e introduzindo conhecimento para o uso de programas e equipamentos de informática, apoio psicossocial e incentivo à construção da cidadania.',
        documentos: [
            { nome: 'Convênio', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-dom-helder-2025/convenio.pdf' }
        ],
        parcelas: [
            { numero: '1ª/12ª', data: '04/06/2025', valor: 'R$ 12.000,00', dataFinal: '04/07/2025', dataPc: '17/06/2025', situacao: 'REGULAR' },
            { numero: '2ª/12ª', data: '27/06/2025', valor: 'R$ 12.000,00', dataFinal: '27/07/2025', dataPc: '14/07/2025', situacao: 'REGULAR' },
            { numero: '3ª/12ª', data: '04/08/2025', valor: 'R$ 12.000,00', dataFinal: '03/09/2025', dataPc: '28/08/2025', situacao: 'REGULAR' },
            { numero: '4ª/12ª', data: '05/09/2025', valor: 'R$ 12.000,00', dataFinal: '05/10/2025', dataPc: '17/09/2025', situacao: 'REGULAR' },
            { numero: '5ª/12ª', data: '24/09/2025', valor: 'R$ 12.000,00', dataFinal: '24/10/2025', dataPc: '08/10/2025', situacao: 'REGULAR' },
            { numero: '6ª/12ª', data: '17/10/2025', valor: 'R$ 12.000,00', dataFinal: '16/11/2025', dataPc: '12/11/2025', situacao: 'REGULAR' },
            { numero: '7ª/12ª', data: '21/11/2025', valor: 'R$ 12.000,00', dataFinal: '21/12/2025', dataPc: '11/12/2025', situacao: 'REGULAR' }
        ]
    },
    {
        id: 3,
        convenio: 'Termo de Convênio de Cooperação nº 005/2025',
        entidade: 'Instituto Banco Vermelho - IBV',
        cnpj: '53.306.473/0001-88',
        data: '25/09/2025',
        valor: 'R$ 45.000,00',
        objeto: 'Instalação de um banco gigante vermelho nas dependências da Alepe, acompanhado de ações de conscientização e prevenção à violência contra a mulher, incluindo palestras, materiais informativos, divulgação institucional e inserção da Alepe no mapa oficial do Projeto Banco Vermelho.',
        documentos: [
            { nome: 'Convênio', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/instituto-banco-vermelho/convenio.pdf' }
        ],
        parcelas: [
            { numero: '1ª/1ª', data: '31/10/2025', valor: 'R$ 45.000,00', dataFinal: '09/02/2026', dataPc: '-', situacao: 'EM ABERTO' }
        ]
    },
    {
        id: 4,
        convenio: 'Termo de Convênio de Cooperação nº 001/2025',
        entidade: 'Clube das Máscaras O Galo da Madrugada',
        cnpj: '11.451.275/0001-68',
        data: '24/02/2025',
        valor: 'R$ 290.000,00',
        objeto: 'Execução do projeto "Carnaval Sustentável Galo da Madrugada, Alepe - 2025", sob coordenação do Galo da Madrugada.',
        documentos: [
            { nome: 'Convênio', url: 'https://www.alepe.pe.gov.br/downloads/convenios/com-transferencia/galo-da-madrugada/convenio.pdf' }
        ],
        parcelas: [
            { numero: '1ª/1ª', data: '26/02/2025', valor: 'R$ 290.000,00', dataFinal: '25/04/2025', dataPc: '18/03/2025', situacao: 'REGULAR' }
        ]
    }
];

const conveniosSemTransferencia = [
    {
        id: 1,
        convenio: 'Termo de Adesão',
        entidade: 'Microsoft do Brasil Importação e Comércio de Software e Vídeo Games Ltda.',
        cnpj: '-',
        data: '10/09/2024',
        objeto: 'Termo de Adesão ao Acordo Corporativo nº 8/2020, firmado entre a União, por intermédio da Secretaria de Governo Digital (SGD/MGI), e a empresa Microsoft do Brasil.',
        documentos: [
            { nome: 'Convênio', url: 'https://www.alepe.pe.gov.br/downloads/convenios/sem-transferencia/convenio.pdf' },
            { nome: 'Termo Aditivo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/sem-transferencia/termo-aditivo.pdf' },
            { nome: 'Acordo Corporativo', url: 'https://www.alepe.pe.gov.br/downloads/convenios/sem-transferencia/acordo-corporativo-8.pdf' }
        ]
    }
];

function renderDocumentos(documentos) {
    return documentos.map((doc, i) => (
        <div key={i} style={{ marginBottom: '4px', display: 'flex', alignItems: 'center' }}>
            <a href={doc.url} target="_blank" rel="noopener noreferrer" title={doc.nome} style={{ marginRight: '6px', flexShrink: 0 }}>
                <img src="/img/download-pdf.png" height="16" width="16" alt="PDF" />
            </a>
            <a href={doc.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem' }}>
                {doc.nome}
            </a>
        </div>
    ));
}

function ConvenioRow({ convenio, showParcelas }) {
    const [expanded, setExpanded] = useState(false);
    const colspan = showParcelas ? 8 : 6;

    return (
        <>
            <tr>
                <td>
                    <div>{convenio.convenio}</div>
                    <small className="text-muted">{convenio.cnpj}</small>
                </td>
                <td>{convenio.entidade}</td>
                <td style={{ fontSize: '0.8rem' }}>{convenio.objeto}</td>
                {showParcelas && <td style={{ whiteSpace: 'nowrap' }}>{convenio.valor}</td>}
                <td style={{ whiteSpace: 'nowrap' }}>{convenio.data}</td>
                <td>{renderDocumentos(convenio.documentos)}</td>
                {showParcelas && (
                    <td>
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            style={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}
                            onClick={() => setExpanded(!expanded)}
                        >
                            {expanded ? '▲ Ocultar' : '▼ Parcelas'}
                        </button>
                    </td>
                )}
            </tr>
            {showParcelas && expanded && (
                <tr>
                    <td colSpan={colspan} style={{ background: '#f8f9fa', padding: '12px 24px' }}>
                        <strong>Parcelas Liberadas</strong>
                        <table className="table table-bordered table-sm small mt-2 mb-2">
                            <thead className="table-light">
                                <tr>
                                    <th>Nº</th>
                                    <th>DATA</th>
                                    <th>VALOR</th>
                                    <th>DATA FINAL</th>
                                    <th>DATA PC</th>
                                    <th>SITUAÇÃO</th>
                                </tr>
                            </thead>
                            <tbody>
                                {convenio.parcelas.map((p, i) => (
                                    <tr key={i}>
                                        <td>{p.numero}</td>
                                        <td>{p.data}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{p.valor}</td>
                                        <td>{p.dataFinal}</td>
                                        <td>{p.dataPc}</td>
                                        <td>{p.situacao}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}
        </>
    );
}

export default function Convenios() {
    const today = new Date();
    const monthNames = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    const formattedDate = `${monthNames[today.getMonth()]} de ${today.getFullYear()}`;

    return (
        <div className="container py-4">
            <p>
                <small>Você está em <a href="/financas">Prestação de Contas</a> / Convênios</small>
            </p>
            <h1 className="mb-4">Convênios</h1>
            <p>
                Os convênios são acordos firmados entre a Assembleia Legislativa do Estado de Pernambuco (Alepe) e
                entidades públicas ou privadas para a consecução de objetivos de interesse comum.
                De acordo com o <strong>art. 8º, §1º, inciso II, da Lei de Acesso à Informação (LAI)</strong>,
                devem ser divulgadas as informações relativas a convênios ou instrumentos congêneres.
            </p>

            {/* Seção 1: Com Transferências Realizadas */}
            <h4 className="mt-4 mb-1">Convênios com Transferências de Recursos Realizadas</h4>
            <p className="small text-muted mb-2">
                Convênios em que a Alepe realizou transferência de recursos financeiros a outras entidades.
            </p>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle table-sm small">
                    <thead className="table-light">
                        <tr>
                            <th style={{ width: '180px' }}>CONVÊNIO</th>
                            <th style={{ width: '160px' }}>ENTIDADE BENEFICIÁRIA</th>
                            <th>OBJETO</th>
                            <th style={{ width: '110px' }}>VALOR</th>
                            <th style={{ width: '90px' }}>DATA</th>
                            <th style={{ width: '160px' }}>DOCUMENTOS</th>
                            <th style={{ width: '90px' }}>PARCELAS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conveniosComTransferenciaRealizada.map(convenio => (
                            <ConvenioRow key={convenio.id} convenio={convenio} showParcelas={true} />
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Seção 2: Com Transferências Recebidas */}
            <h4 className="mt-5 mb-1">Convênios com Transferências de Recursos Recebidas</h4>
            <p className="small text-muted mb-2">
                Convênios em que a Alepe recebeu transferências de recursos financeiros de outros órgãos ou entidades.
            </p>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-sm small">
                    <thead className="table-light">
                        <tr>
                            <th style={{ width: '100px' }}>EXERCÍCIO</th>
                            <th>REGISTROS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {['2026', '2025', '2024', '2023'].map(ano => (
                            <tr key={ano}>
                                <td><strong>{ano}</strong></td>
                                <td>Não há registros de convênios com transferências de recursos recebidas.</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Seção 3: Sem Transferências */}
            <h4 className="mt-5 mb-1">Convênios sem Transferências de Recursos</h4>
            <p className="small text-muted mb-2">
                Convênios celebrados sem transferência de recursos financeiros, como acordos de cooperação técnica.
            </p>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle table-sm small">
                    <thead className="table-light">
                        <tr>
                            <th style={{ width: '160px' }}>CONVÊNIO</th>
                            <th style={{ width: '220px' }}>ENTIDADE PARCEIRA</th>
                            <th>OBJETO</th>
                            <th style={{ width: '90px' }}>DATA</th>
                            <th style={{ width: '160px' }}>DOCUMENTOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conveniosSemTransferencia.map(convenio => (
                            <ConvenioRow key={convenio.id} convenio={convenio} showParcelas={false} />
                        ))}
                    </tbody>
                </table>
            </div>

            <p className="mt-5 mb-5">
                <small>Informação atualizada em: {formattedDate}.</small>
            </p>
        </div>
    );
}
